import type { SWRConfiguration } from 'swr'
import useSWRImmutable from 'swr/immutable'

import { useApis } from '../contexts/api-context'
import { type SubscriptionType } from '../types/SubscriptionType'

const fetchAvailableSubscriptions = async (api: any, initPrice?: number): Promise<SubscriptionType[]> => {
  const res = await api.getSubscriptions(initPrice)
  return res.data
}

const useSubscriptionPlans = (initPrice?: number, options?: SWRConfiguration) => {
  const { api } = useApis()

  const { data } = useSWRImmutable(
    ['availableSubscriptions', initPrice],
    () => fetchAvailableSubscriptions(api, initPrice),
    options,
  )

  return { allSubscriptions: data, visibleSubscriptions: data?.filter((plan) => plan.visible) }
}

export default useSubscriptionPlans
